import axios from 'axios';
import axiosInstance from './base.api';
import { getEnvironmentVariable, getGuestInfo } from '../utils';

interface PageDTO {
    id: number,
    title: string,
    icon: string,
    position: number,
    route: string,
    tag: string | null,
    type: string,
    content: string,
    metha: string | null,
    viewport: string | null,
    author: string | null,
    keywords: string | null,
    description: string,
    enabled: number
}

export type TrackActivityPayload = {
    app_id: number | string;
    event: string;
    action: string;
    field: string;
    row_id?: number | string;
    referenced_row_id?: number | string;
    url?: string;
    link?: string;
};

const platformUrl = getEnvironmentVariable('REACT_APP_PLATFORM_URL');

export const getTermsOfUse = async () => {
    const response = await axios.post<PageDTO>(
        `${platformUrl}/pages/detail?route=termsofuse`,
    );

    const {
        title,
        description,
        content,
    } = response.data;

    return {
        title,
        description,
        content,
    };
};

export const trackActivity = async (
    data: TrackActivityPayload,
): Promise<void> => {
    const guestInfo = getGuestInfo();

    await axiosInstance.post(
        `${platformUrl}/activity`,
        {
            ...data,
            ...(guestInfo && {
                guestInfo,
            }),
        },
    );
};